import Vue from 'vue'

export const state = () => ({
  settings: {
    shop_vat: 21,
    address: null,
    reg_nr: null,
    phone_number: null,
    email: null,
    site_title: null,
    site_description: null,
    facebook: null,
    twitter: null,
    instagram: null
  }
})

// getters
export const getters = {
  settings: (state) => {
    return state.settings
  },
  vat: (state) => {
    return state.settings.shop_vat
  }
}

// mutations
export const mutations = {
  setSettings (state, settings) {
    state.settings = settings
  }
}

// actions
export const actions = {
  async fetchSettings ({ commit }) {
    try {
      const settings = await this.$axios.get('/settings')
      commit('setSettings', settings.data)
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  }
}
